import { DatePipe } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { BlinkDirective } from '@zero/shared/ui-directives';
import { PriceScalePipe } from '@zero/shared/ui-pipes';
import { Asset, InstrumentType, OrderDirection, Quote } from '@zero/shared/util-models';
import { differenceInCalendarDays } from 'date-fns';

@Component({
  selector: 'trade-confirm-quote',
  templateUrl: './trade-confirm-quote.component.html',
  styleUrls: ['./trade-confirm-quote.component.scss'],
  imports: [BlinkDirective, DatePipe, PriceScalePipe],
})
export class TradeConfirmQuoteComponent implements OnChanges {
  @Input() public asset?: Asset;
  @Input() public quote?: Quote;
  @Input() public direction?: OrderDirection;

  public isQuoteOld = false;
  public isCrypto = false;

  public ngOnChanges(): void {
    if (!this.quote) {
      return;
    }

    const { time } = this.quote;
    this.isQuoteOld = !time || time.length < 3 ? false : differenceInCalendarDays(Date.now(), Date.parse(time)) > 0;
    this.isCrypto = this.asset?.instrumentType === InstrumentType.Crypto;
  }
}
